export default __webpack_public_path__ + "static/media/BackgroundCreateNewKahsh.04ec8d5e.png";